import { activeControlPin } from 'services/api/user/controlPin/active';
import { changeControlPin } from 'services/api/user/controlPin/change';
import { checkControlPin } from 'services/api/user/controlPin/check';
import { modifyControlPin } from 'services/api/user/controlPin/modify';
import { remindControlPin } from 'services/api/user/controlPin/remind';
import { setControlPin } from 'services/api/user/controlPin/set';
import { statusControlPin } from 'services/api/user/controlPin/status';
import { getCounterValidEmail } from 'services/api/user/email/counterValid';

import * as actionType from './actionTypes';

export const onActiveControlPin = (
  emailParams,
  activeParams,
) => async dispatch => {
  dispatch(actionType.controlPinBegin());
  const respValidEmail = await getCounterValidEmail(emailParams);
  if (respValidEmail.error) {
    return dispatch(actionType.controlPinError(respValidEmail));
  }
  const respActive = await activeControlPin(activeParams);
  if (respActive.error) {
    return dispatch(actionType.controlPinError(respActive));
  }
  return dispatch(actionType.controlPinActive(respActive));
};

export const onChangeControlPin = params => dispatch => {
  dispatch(actionType.controlPinBegin());
  return changeControlPin(params)
    .then(payload => {
      if (payload.error) dispatch(actionType.controlPinError(payload));
      else dispatch(actionType.controlPinChange(payload));
    })
    .catch(error => {
      dispatch(actionType.controlPinError(error));
    });
};

export const onDesactiveControlPin = params => async dispatch => {
  dispatch(actionType.controlPinBegin());

  const respModify = await modifyControlPin(params);
  if (respModify.error) return dispatch(actionType.controlPinError(respModify));

  await dispatch(onStatusControlPin());
  return dispatch(actionType.controlPinModify(respModify));
};

export const onModifyControlPin = (
  checkParams,
  modifyParams,
) => async dispatch => {
  dispatch(actionType.controlPinBegin());
  const respCheck = await checkControlPin(checkParams);
  if (respCheck.error) {
    return dispatch(actionType.controlPinError(respCheck));
  }
  const respModify = await modifyControlPin(modifyParams);
  if (respModify.error) {
    return dispatch(actionType.controlPinError(respModify));
  }
  await dispatch(onStatusControlPin());
  return dispatch(actionType.controlPinModify(respModify));
};

export const onRemindControlPin = params => dispatch => {
  dispatch(actionType.controlPinBegin());
  return remindControlPin(params)
    .then(payload => {
      if (payload.error) dispatch(actionType.controlPinError(payload));
      else dispatch(actionType.controlPinRemind(payload));
    })
    .catch(error => {
      dispatch(actionType.controlPinError(error));
    });
};

export const onSetControlPin = params => dispatch => {
  dispatch(actionType.controlPinBegin());
  return setControlPin(params)
    .then(payload => {
      if (payload.error) dispatch(actionType.controlPinError(payload));
      else dispatch(actionType.controlPinSet(payload));
    })
    .catch(error => {
      dispatch(actionType.controlPinError(error));
    });
};

export const onStatusControlPin = params => dispatch => {
  dispatch(actionType.controlPinBegin());
  return statusControlPin(params)
    .then(payload => {
      if (payload.error) dispatch(actionType.controlPinError(payload));
      else dispatch(actionType.controlPinStatus(payload));
    })
    .catch(error => {
      dispatch(actionType.controlPinError(error));
    });
};
